<template>
  <BaseModal :value="true" class="customer-modal" @input="$emit('close')">
    <h1 class="mb-8">{{ $t("message.new_customer_modal.title") }}</h1>
    <div class="flex flex-col">
      <form>
        <div class="relative">
          <div class="mb-4">
            <label for="email">{{
              $t("message.new_customer_modal.email")
            }}</label>
            <input
              name="email"
              id="email"
              class="regular full bordered"
              type="email"
              v-model="customer.email"
            />
          </div>
          <div class="mb-4">
            <label for="name">{{
              $t("message.new_customer_modal.name")
            }}</label>
            <input
              name="name"
              id="name"
              class="regular full bordered"
              type="name"
              v-model="customer.name"
            />
          </div>
          <div class="mb-4">
            <label for="surname">{{
              $t("message.new_customer_modal.surname")
            }}</label>
            <input
              surname="surname"
              id="surname"
              class="regular full bordered"
              type="surname"
              v-model="customer.surname"
            />
          </div>
          <div class="mb-4">
            <label for="company">{{
              $t("message.new_customer_modal.company")
            }}</label>
          </div>
          <div class="mb-4">
            <label for="seller">{{
              $t("message.new_customer_modal.seller")
            }}</label>
          </div>
          <div class="mb-4">
            <label for="surname">{{
              $t("message.new_customer_modal.price_level")
            }}</label>
          </div>
          <div class="mb-4">
            <label for="credit">{{
              $t("message.new_customer_modal.credit")
            }}</label>
          </div>
          <div class="mb-4">
            <label for="Taxable">{{
              $t("message.new_customer_modal.tax_label")
            }}</label>
          </div>
          <button
            class="btn btn btn-dark-button mt-4 left-auto bottom-2"
            type="submit"
          >
            {{ $t("message.new_customer_modal.confirm_customer") }}
          </button>
          <h1 class="text-red-700">
            {{ $t("message.new_customer_modal.work_in_progress") }}
          </h1>
        </div>
      </form>
    </div>
  </BaseModal>
</template>
<script>
export default {
  data() {
    return {
      customer: {
        email: "",
        priceLevel: ""
      }
    };
  }
};
</script>
<style lang="postcss">
.customer-modal {
  width: 100%;
}
.customer-modal.modal .modal-content {
  max-width: 600px;
  padding: 30px !important;
}
</style>
